<!-- Analytics Card -->
<div class="analytics-card">
  <div class="card-body">
    <div class="mb-3">
      <h5 class="card-title mb-1">Layered Protection</h5>
      <p class="card-subtitle text-muted">
        This chart shows the number of threats that Microsoft would deliver to the Inbox vs. Junk folder, if it wasn't
        for the additional Layered Protection.
      </p>
    </div>

    <div class="chart-container">
      @if (isLoading()) {
        <kendo-loader
          [type]="'infinite-spinner'"
          [size]="'large'"
        ></kendo-loader>
      } @else if (chartData().length > 0) {
        <div class="d-flex justify-content-center">
          <!-- Chart -->
          <div class="chart-wrapper position-relative">
            <div
              echarts
              [options]="chartOptions()"
              [initOpts]="{ renderer: 'canvas' }"
              style="height: 300px; width: 400px"
              class="chart-container"
            ></div>
            <!-- Total in center -->
            <div class="chart-center-text position-absolute">
              <div class="fw-bold fs-3">{{ totalThreats | number }}</div>
              <div class="text-muted small">Total</div>
            </div>
          </div>
        </div>
      } @else {
        <div class="text-center text-muted py-4">
          <h6>No Data Available</h6>
        </div>
      }
    </div>
  </div>
</div>
